/**
 * Zoho Inbound Lead Form - client-side field rules.
 * HTML export does not include Zoho field rules; this mirrors the hosted form UI.
 * Keep input name attributes unchanged for Zoho submit.
 */
(function () {
  var BASE_MANDATORY = [
    'Name_First',
    'Name_Last',
    'PhoneNumber_countrycode',
    'PhoneNumber_countrycodeVal',
    'Email',
    'Dropdown1'
  ];

  // selectedIndex -> visible field keys (wrapper lookup keys)
  // 0 = -Select-
  var RULES = {
    1: ['SingleLine', 'MultiLine3', 'Address3', 'FileUpload1'],
    2: ['MultiLine1', 'Address1', 'FileUpload1'],
    3: ['SingleLine', 'MultiLine3', 'Address3', 'FileUpload'],
    4: ['Address1', 'FileUpload2', 'MultiLine5'],
    5: ['FileUpload', 'MultiLine5'],
    6: ['SingleLine', 'MultiLine3', 'Address3'],
    7: ['MultiLine6', 'Radio1'],
    8: ['MultiLine6', 'Radio1'],
    9: ['MultiLine']
  };

  // Extra mandatory field names when that path is active (beyond BASE)
  var PATH_MANDATORY = {
    2: ['Address1_AddressLine1', 'Address1_City', 'Address1_Region', 'Address1_ZipCode'],
    3: ['FileUpload'],
    4: ['Address1_AddressLine1', 'Address1_City', 'Address1_Region', 'Address1_ZipCode', 'FileUpload2', 'MultiLine5'],
    5: ['FileUpload', 'MultiLine5'],
    7: ['MultiLine6', 'Radio1'],
    8: ['MultiLine6', 'Radio1'],
    9: ['MultiLine']
  };

  var SHIPPING_ADDRESS_FIELDS = [
    'Address_AddressLine1',
    'Address_City',
    'Address_Region',
    'Address_ZipCode'
  ];

  var LEGACY_RADIO_NAMES = ['Radio', 'Radio2', 'Radio3', 'Radio4', 'Radio5'];

  var FIELD_LOOKUP = [
    'SingleLine',
    'MultiLine3',
    'Address3',
    'MultiLine1',
    'Address1',
    'FileUpload1',
    'FileUpload',
    'FileUpload2',
    'MultiLine',
    'MultiLine5',
    'MultiLine6',
    'Radio1',
    'Address',
    'Dropdown1'
  ];

  function wrapperFor(form, key) {
    if (key === 'Address' || key === 'Address1' || key === 'Address3') {
      var byId = form.querySelector('#' + key);
      if (byId) return byId;
    }

    var selectors = [
      '[name="' + key + '"]',
      '[name^="' + key + '_"]'
    ];
    var i;
    var el;
    for (i = 0; i < selectors.length; i++) {
      el = form.querySelector(selectors[i]);
      if (el) {
        return el.closest('.zf-tempFrmWrapper') || el.closest('[class*="zf-tempFrmWrapper"]');
      }
    }

    // File inputs and radios sometimes need exact match preference for FileUpload vs FileUpload1/2
    if (key === 'FileUpload') {
      el = form.querySelector('input[type="file"][name="FileUpload"]');
      if (el) return el.closest('.zf-tempFrmWrapper');
    }
    return null;
  }

  function legacyWrappers(form) {
    var found = [];
    var seen = {};
    LEGACY_RADIO_NAMES.forEach(function (name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (!el) return;
      var wrap = el.closest('.zf-tempFrmWrapper');
      if (wrap && !seen[name]) {
        seen[name] = true;
        found.push(wrap);
      }
    });
    return found;
  }

  function setHidden(wrap, hide) {
    if (!wrap) return;
    if (hide) {
      wrap.classList.add('zf-field-hidden');
      wrap.setAttribute('hidden', 'hidden');
      wrap.style.display = 'none';
    } else {
      wrap.classList.remove('zf-field-hidden');
      wrap.removeAttribute('hidden');
      wrap.style.display = '';
    }
  }

  function clearWrapper(wrap) {
    if (!wrap) return;
    var fields = wrap.querySelectorAll('input, textarea, select');
    Array.prototype.forEach.call(fields, function (field) {
      var type = (field.type || '').toLowerCase();
      if (type === 'radio' || type === 'checkbox') {
        field.checked = false;
      } else if (type === 'file') {
        field.value = '';
      } else if (field.tagName === 'SELECT') {
        field.selectedIndex = 0;
      } else {
        field.value = '';
      }
    });
    var errors = wrap.querySelectorAll('.zf-errorMessage');
    Array.prototype.forEach.call(errors, function (err) {
      err.style.display = 'none';
    });
  }

  function shippingYes(form) {
    var yes = form.querySelector('input[name="Radio1"][value="Yes"]');
    return !!(yes && yes.checked);
  }

  function updateMandatory(pathIndex, form) {
    var mand = BASE_MANDATORY.slice();
    var extra = PATH_MANDATORY[pathIndex] || [];
    mand = mand.concat(extra);

    if ((pathIndex === 7 || pathIndex === 8) && shippingYes(form)) {
      mand = mand.concat(SHIPPING_ADDRESS_FIELDS);
    }

    window.zf_MandArray = mand;
  }

  function applyRules(form) {
    var dropdown = form.querySelector('select[name="Dropdown1"]');
    if (!dropdown) return;

    var pathIndex = dropdown.selectedIndex;
    var visible = RULES[pathIndex] || [];
    var showShippingAddress = (pathIndex === 7 || pathIndex === 8) && shippingYes(form);

    // Hide legacy radio branches always
    legacyWrappers(form).forEach(function (wrap) {
      setHidden(wrap, true);
      clearWrapper(wrap);
    });

    FIELD_LOOKUP.forEach(function (key) {
      if (key === 'Dropdown1') return;
      var wrap = wrapperFor(form, key);
      if (!wrap) return;

      var shouldShow = visible.indexOf(key) !== -1;
      if (key === 'Address') {
        shouldShow = showShippingAddress;
      }

      if (shouldShow) {
        setHidden(wrap, false);
      } else {
        setHidden(wrap, true);
        clearWrapper(wrap);
      }
    });

    updateMandatory(pathIndex, form);
  }

  function showThankYouIfNeeded() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('zoho_posted') !== 'true') return false;

      var thanks = document.getElementById('zoho-contact-thanks');
      var wrap = document.getElementById('zoho-contact-form-wrap');
      if (!thanks || !wrap) return false;

      wrap.hidden = true;
      wrap.style.display = 'none';
      thanks.hidden = false;
      thanks.removeAttribute('hidden');

      // Keep URL shareable but avoid re-showing form on refresh with stale query if desired:
      // leave query in place so refresh still shows thanks.
      if (thanks.scrollIntoView) {
        thanks.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function init() {
    if (showThankYouIfNeeded()) return;

    var form = document.forms.form || document.getElementById('form');
    if (!form) return;

    var dropdown = form.querySelector('select[name="Dropdown1"]');
    if (dropdown) {
      dropdown.addEventListener('change', function () {
        applyRules(form);
      });
    }

    Array.prototype.forEach.call(form.querySelectorAll('input[name="Radio1"]'), function (radio) {
      radio.addEventListener('change', function () {
        applyRules(form);
      });
    });

    applyRules(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
